import { Box, Stack, Typography } from '@mui/material'
import { LocationSweepstakeDetailsHeader } from './LocationSweepstakeDetailsHeader'
import { useParams } from 'react-router-dom'
import { useGetSweepstakeById } from 'hooks/api/useGetSweepstakeById'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { isNil } from 'lodash'

import { SweepstakeEntryMultiplierSection } from '../SweepstakeEntryMultiplier/SweepstakeEntryMultiplierSection'

export const LocationSweepstakeDetailsSettingsPage = () => {
  const { id: idParam } = useParams()
  const sweepstakeId = Number(idParam)
  const sweepstakeQuery = useGetSweepstakeById({ sweepstakeId })

  if (isNil(idParam)) {
    throw Error('Id Param Missing')
  }

  if (sweepstakeQuery.isPending) {
    return <ActivityIndicator />
  }

  if (sweepstakeQuery.isError || isNil(sweepstakeQuery.data)) {
    return <Box>An error occurred fetching the sweepstake.</Box>
  }

  const sweepstake = sweepstakeQuery.data
  const sweepstakeData = sweepstake.sweepstakeData

  if (!sweepstakeData) {
    return (
      <LocationSweepstakeDetailsHeader
        sweepstake={sweepstake}
        currentTab={`/LocationSweepstakes/${sweepstake.id}/Settings`}
      >
        <Stack>
          <Typography variant="h4">
            We had an issue with the sweepstake data.
          </Typography>
        </Stack>
      </LocationSweepstakeDetailsHeader>
    )
  }

  return (
    <LocationSweepstakeDetailsHeader
      sweepstake={sweepstake}
      currentTab={`/LocationSweepstakes/${sweepstake.id}/Settings`}
    >
      <Stack gap={'40px'}>
        <SweepstakeEntryMultiplierSection sweepstake={sweepstake} />
      </Stack>
    </LocationSweepstakeDetailsHeader>
  )
}
